<template>
  <div class="edit-dialog" @contextmenu.stop>
    <el-dialog
      title="添加白名单"
      width="400px"
      height="300px"
      top="calc( 50vh - 150px )"
      custom-class="edit-share"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="setting-container">
        <div class="setting-item">
          <el-radio v-model="module" class="title-radio" :label="0">单独添加：</el-radio>
          <div class="username">
            <span style="margin-left: 50px">请输入用户名：</span>
            <el-input :disabled="module === 1" v-model="username"></el-input>
          </div>
        </div>
        <div class="setting-item">
          <el-radio v-model="module" class="title-radio" :label="1">批量添加：</el-radio>
          <div class="username">
            <label class="uploading" :class="{ disabled: module === 0 }" for="uploadExcel" @click="uploadHandler($event)">上传白名单列表</label>
            <input type="file" id="uploadExcel" ref="uploadExcel" @change="addFile($event)" accept=".xlsx" style="display: none" />
            <span>{{ excelFileName }}</span>
          </div>
          <a style="font-size: 12px;color: #ff8d1a;text-decoration: none;margin-left: 60px;" href="/ebook/cloudReadSubscribe/downLoadExcelPbsjTemplate">下载模版</a>
        </div>
      </div>
      <div class="default-edit-footer" id="edit-footer">
        <div class="edit-footer-item left" @click="save()">保存</div>
        <div class="edit-footer-item right" @click="handleCancel()">取消</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import chargeManager from '@api/chargeManager'

export default {
  name: 'SubscribeAddDialog',
  data() {
    return {
      module: 0,
      dialogVisible: false,
      username: '',
      fileData: null,
      excelFileName: '',
      goodsId: 0
    }
  },
  props: {
    goodsObj: {
      default: null,
      type: Object
    }
  },
  computed: {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    uploadHandler(e) {
      if (this.module === 0) {
        e.preventDefault()
      }
    },
    addFile(e) {
      this.fileData = e.target.files[0]
      if (this.fileData) {
        this.excelFileName = this.fileData.name
      }
    },
    save() {
      let params = new FormData()
      params.append('worksId', this.goodsObj.worksId.toString())
      params.append('worksType', this.goodsObj.worksType.toString())
      if (this.module === 1) {
        if (!this.fileData) {
          this.$message.error('请上传文件')
          return
        }
        params.append('dataFile', this.fileData)
      } else {
        if (!this.username.trim()) {
          this.$message.error('请输入用户名')
          return
        }
        params.append('userName', this.username)
      }
      chargeManager.addSubscribe(params).then((res) => {
        if (res.data.status === 0) {
          this.$message({
            message: res.data.message,
            type: 'success'
          })
          this.username = ''
          this.fileData = null
          this.dialogVisible = false
          this.excelFileName = ''
          this.$refs.uploadExcel.value = null
          this.$emit('savedData')
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.setting-container {
  width: 100%;
  .setting-item {
    margin-bottom: 10px;
    font-size: 14px;
    .title {
      width: 65px;
    }
    span {
      margin-right: 10px;
    }
    .username {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .el-input {
        width: 150px;
        text-align: left;
      }
      .uploading {
        border: 1px solid #e5e5e5;
        padding: 3px 5px;
        border-radius: 5px;
        color: #3a3a3a;
        font-size: 14px;
        margin: 0 10px 0 50px;
      }
      .disabled {
        color: #c0c4cc;
      }
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.setting-item {
  .username {
    .el-input {
      .el-input__inner {
        text-align: left;
        padding-left: 5px;
      }
    }
  }
  .title-radio {
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
</style>
